/**
 * Elective 1065 — KUK Electives.
 *
 * Elective names as a tab list beside a card of that elective's subjects and the
 * semester each falls in. Ported from kuk-campus-portal
 * `components/Degree/Electives.tsx`.
 *
 * The rows reuse the existing three-level elective store unchanged:
 *   category = one elective (the tab) → semester = "3rd Sem" → subject = a table row.
 * The nested category / semester / subject forms are Elective 1's, verbatim, because
 * the shape is identical and the labels already say the right thing; only the
 * section-level defaults differ (KUK's heading, colours and empty sub-title).
 *
 * The table's column labels ("Subject", "Semester") are literals in the reference's
 * markup, not values it receives, so they stay literals in the widget rather than
 * becoming two columns nobody would change.
 *
 * `elective_subject.credits` is collected by the shared subject form and is not drawn
 * by this variant — the reference's table has no credits column. Stored, so a later
 * variant can show it without a migration.
 *
 * Every field maps to a column that already exists — the variant adds no schema of its
 * own beyond widening `elective.variant`.
 */

import { ELECTIVE_1_CONSTANTS } from "./elective_1";

export const ELECTIVE_1065_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    subject_name: "",
    credits: 0,
    priority: 1,
  },

  ELECTIVE_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Electives",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Electives",
      required: false,
      defaultValue: "Electives",
    },
    {
      fieldName: "title_text_color",
      label: "Heading + table text colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "sub_title",
      label: "Supporting line",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Optional — the reference shows none",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "sub_title_text_color",
      label: "Supporting line colour",
      value: "#4B4B4B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#4B4B4B",
      required: false,
      defaultValue: "#4B4B4B",
    },
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  CATEGORY_FIELDS_CONFIG: ELECTIVE_1_CONSTANTS.CATEGORY_FIELDS_CONFIG,
  SEMESTER_FIELDS_CONFIG: ELECTIVE_1_CONSTANTS.SEMESTER_FIELDS_CONFIG,
  SUBJECT_TABLE_FIELDS_CONFIG: ELECTIVE_1_CONSTANTS.SUBJECT_TABLE_FIELDS_CONFIG,
};
